module.exports = {
      id: "ic-crosshair-tooltip-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-crosshair-tooltip-usage",
      toString: function () {
        return this.url;
      }
    }